import { render, staticRenderFns } from "./BraintreeMerchantId.vue?vue&type=template&id=830aa81e&"
import script from "./BraintreeMerchantId.vue?vue&type=script&lang=ts&"
export * from "./BraintreeMerchantId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports